import { Button } from '@/components/ui/Button';
import { UI_STRINGS } from '@/lib/constants/ui-strings';

const T = UI_STRINGS.VIEW_AS;

/**
 * Where a view-as tab lands once its session has ended (MYN-335): Exit, the
 * 30 minute limit, or the admin losing the permission. Standalone, no shell:
 * nothing else in the tab can load any more.
 */
export function ViewAsEndedPage() {
  return (
    <main className="bg-page-bg flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-text-primary text-xl font-semibold">{T.ENDED_TITLE}</h1>
      <p className="text-text-secondary max-w-md text-sm">{T.ENDED_DESCRIPTION}</p>
      <Button variant="outline" onClick={() => window.close()}>
        {T.CLOSE_TAB}
      </Button>
    </main>
  );
}
